export default function inputField() {
    if (document.querySelector(".field-input")) {
        const input = document.querySelector(".field-input input");
        const text = document.querySelector(".field-input p");

        input.addEventListener("change", (e) => {
            text.textContent = input.files[0].name;
        });
    }
}